import { S3_HOST } from "./urlconstants";
import register_icon from "@/assets/images/new/register-icon.svg";
import news_img from "@/assets/images/new/ad-news.png";
import Expert from "@/assets/images/new/Expert.png";
import Story from "@/assets/images/new/Story.png";

import events_img from "@/assets/images/new/ad-events.png";
import build_ads_img from "@/assets/images/new/add-board.png";
import sell_service_img from "@/assets/images/new/sell-services.svg";
import buy_service_img from "@/assets/images/new/purchase.svg";
import service_img from "@/assets/images/new/services.svg";
import offer_service_img from "@/assets/images/new/offer-zone.svg";
import adzone_service_img from "@/assets/images/new/ad-zone.svg";
import about_us_img from "@/assets/images/about_right.png";
import about_us_page_img from "@/assets/images/img_ca1.jpg";
import profileImg from "@/assets/images/profile.jpg";
import leftArrowIcon from "@/assets/images/new/left-arrow.svg";
import rightArrowIcon from "@/assets/images/new/right-arrow.svg";
import shareIcon from "@/assets/images/new/share-icon.svg";
import FarmerImg from "@/assets/images/farmer.png";
import DealerImg from "@/assets/images/dealer.png";
import AgriImg from "@/assets/images/agri.png";
import pillarx_logo from "@/assets/images/pillarx_logo.png";
import offline_selling_logo from "@/assets/images/offline_selling_logo.png";
import LaptopMockupImg from "@/assets/images/laptop-mockup.png";


import COORDINATOR_IMAGE from "@/assets/images/coordinator.png";
import ServiceProviderIMG from "@/assets/images/service_provider.png";
import OtherIMG from "@/assets/images/other.png";
import ProfileIMGPNG from "@/assets/images/profile.png";
import RupeeImg from "@/assets/images/rupee_icon.png";
import FarmerIconImg from "@/assets/images/farmer_icon.png";
import NoIMG from "@/assets/images/no_post.png";
import DASH_FARMER_ICON from "@/assets/images/dashboard/d_farmer_icon.png";
import DASH_DEALER_ICON from "@/assets/images/dashboard/d_dealer_icon.png";
import DASH_SP_ICON from "@/assets/images/dashboard/d_sp_icon.png";
import DASH_AGRI_ICON from "@/assets/images/dashboard/d_agri_icon.png";
import DASH_COORDINATOR_ICON from "@/assets/images/dashboard/d_c_icon.png";
import MilkCans from "@/assets/images/new/milk-cans.png";
import MONEY_COORDINATOR_IMAGE from "@/assets/images/money_coordinator.png";
import LeadBannerImg from "@/assets/images/lead_banner.png";
import PurchaseBannerImg from "@/assets/images/purchase_banner.png";
import ViewDealerBannerImg from "@/assets/images/view_dealer.png";
import FrameImageUser from "@/assets/images/user_profile/Frame_image.png";

import BestDealUser from "@/assets/images/user_profile/best_deal.png";
import CatlogUser from "@/assets/images/user_profile/catlog.png";
import OfferUser from "@/assets/images/user_profile/offer.png";
import ProuctUser from "@/assets/images/user_profile/product.png";

import BlackBestDealUser from "@/assets/images/user_profile/black_best_deal.png";
import BlackCatlogUser from "@/assets/images/user_profile/black_catlog.png";
import BlackOfferUser from "@/assets/images/user_profile/black_offer.png";
import BlackProuctUser from "@/assets/images/user_profile/black_product.png";
import PurchaseRequestThumbnail from "@/assets/images/purchase-request-thumbnail.png";

import C_ICON from "@/assets/images/register/customer.png";
import ARCHITECT_ICON from "@/assets/images/register/architect.png";
import BDB_ICON from "@/assets/images/register/bbd.png";
import BD_ICON from "@/assets/images/register/bd.png";
import SP_ICON from "@/assets/images/register/sp.png";
import SE_ICON from "@/assets/images/register/se.png";
import IC_ICON from "@/assets/images/register/ic.png";
import D_ICON from "@/assets/images/register/d.png";
import REFERRAL_CARD from "@/assets/images/dashboard/referral-card-image.png";
import REFERRAL_IMAGE from "@/assets/images/dashboard/referral-image.png";



// dashboard
export const DASH_IMG_AGRI = DASH_AGRI_ICON
export const DASH_IMG_SP = DASH_SP_ICON
export const DASH_IMG_COORDINATOR = DASH_COORDINATOR_ICON
export const DASH_IMG_FARMER = DASH_FARMER_ICON
export const DASH_IMG_DEALER = DASH_DEALER_ICON

export const COMPANY_LOGO = S3_HOST + "/images/logos/company-logo.png";
export const APP_STORE_IMG = S3_HOST + "/images/icons/app-store-download-app.png";
export const PLAY_STORE_IMG = S3_HOST + "/images/icons/play-store-download-app.png";
export const NO_IMAGE = S3_HOST + "/images/icons/no-image.png";
export const PILLARX_LOGO = pillarx_logo;
export const OFFLINE_SELLING_LOGO = offline_selling_logo;

export const DEALER_REG_BANNER = S3_HOST + "/images/banner/dealer-register-banner.png";
export const SERVICE_PROVIDER_REG_BANNER = S3_HOST + "/images/banner/service-provider-register-banner.png";

export const PROFILE_PLACEHOLDER_IMG = profileImg;

export const NEWS_IMG = news_img
export const Expert_IMG = Expert
export const Story_IMG = Story
export const PURCHASE_REQUEST_THUMBNAIL = PurchaseRequestThumbnail;
export const EVENTS_IMG = events_img;
export const USER_STORIES_IMG = S3_HOST + '/images/home/check-stories.png';
export const EXPERT_REVIEW_IMG = S3_HOST + '/images/home/check-reviews.png'

export const BUILD_ADS_IMG = build_ads_img;
export const SELL_SERVICE_IMG = sell_service_img;
export const BUY_SERVICE_IMG = buy_service_img;
export const SERVICE_IMG = service_img;
export const OFFER_SERVICE_IMG = offer_service_img;
export const ADZONE_SERVICE_IMG = adzone_service_img;
export const ABOUT_US_IMG = about_us_img;
export const ABOUT_US_IMG2 = about_us_page_img;

export const REGISTER_ICON = register_icon;
export const LEFT_ARROW_ICON = leftArrowIcon;
export const RIGHT_ARROW_ICON = rightArrowIcon;
export const SHARE_ICON = shareIcon;
export const NO_IMG = NoIMG;
export const FARMER_ICON_IMG = FarmerIconImg;
export const DEALER_IMG = DealerImg;
export const COORDINATOR_IMG = COORDINATOR_IMAGE;
export const MONEY_COORDINATOR_IMG = MONEY_COORDINATOR_IMAGE;
export const Lead_Banner_IMG = LeadBannerImg;
export const Purchase_Banner_IMG = PurchaseBannerImg;
export const View_Dealer_Banner_IMG = ViewDealerBannerImg;

// User Profile card images 
export const BESTDEAL_USER_IMG = BestDealUser;
export const CATLOG_USER_IMG = CatlogUser;
export const FRAME_USER_IMG = FrameImageUser;
export const OFFER_USER_IMG = OfferUser;
export const PRODUCT_USER_IMG = ProuctUser;

export const BLACK_BESTDEAL_USER_IMG = BlackBestDealUser;
export const BLACK_CATLOG_USER_IMG = BlackCatlogUser;
export const BLACK_OFFER_USER_IMG = BlackOfferUser;
export const BLACK_PRODUCT_USER_IMG = BlackProuctUser;



export const AGRI_IMAGE = AgriImg;
export const SERVICE_IMAGE = ServiceProviderIMG;
export const OTHER_IMAGE = OtherIMG;
export const RUPEE_IMG = RupeeImg;
export const PROFILE_IMG_PNG = ProfileIMGPNG;
export const MILK_CANS_IMG = MilkCans;

export const GD_MACHINERY = S3_HOST + "/deal-banner/gd-machinery.png";
export const GD_TYRES = S3_HOST + "/deal-banner/gd-tyres.png";
export const BANNER_GIF = S3_HOST + "/images/ad-banners/top-banner-moving.gif";
export const LAPTOP_MOCKUP_IMG = LaptopMockupImg;

export const CUSTOMER_ICON_IMG = C_ICON;
export const ARCHITECT_ICON_IMG = ARCHITECT_ICON;
export const BDB_ICON_IMG = BDB_ICON;
export const BD_ICON_IMG = BD_ICON;
export const SP_ICON_IMG = SP_ICON;
export const SE_ICON_IMG = SE_ICON;
export const IC_ICON_IMG = IC_ICON;
export const D_ICON_IMG = D_ICON;
export const REFERRAL_CARD_IMG = REFERRAL_CARD;
export const REFERRAL_IMG = REFERRAL_IMAGE;
